module.exports = __webpack_public_path__ + "img/Zakiya Lai.bdb4697b.jpg";